import React from "react";
import * as S from "./styles";
export var TabItem = function TabItem(_ref) {
  var e = _ref.ariaControls,
      t = _ref.children,
      a = _ref.className,
      o = _ref.tabIndex,
      r = _ref.handleClick,
      n = _ref.handleMouseEnter,
      s = _ref.handleMouseLeave,
      c = _ref.opacity;
  return React.createElement(S.Item, {
    key: "tab-" + o,
    "data-index": o,
    className: a,
    role: "tab",
    "aria-controls": e,
    "aria-selected": !0,
    tabIndex: "0",
    "data-testid": "tab-menu-tab-" + o,
    style: {
      opacity: c
    },
    onKeyUp: function onKeyUp(e) {
      var t = e.currentTarget;
      "Enter" === e.key && r(o, t);
    },
    onClick: function onClick(e) {
      var t = e.currentTarget;
      r(o, t);
    },
    onMouseEnter: function onMouseEnter() {
      return n(o);
    },
    onMouseLeave: function onMouseLeave() {
      return s();
    }
  }, t);
};
export default TabItem;